// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2547":"cf9b7ea7","8688":"c979e12a","8864":"d4c32a44","9102":"7b0b8204"}[chunkId] + ".chunk.css";
};